import { render, staticRenderFns } from "./noticelist.vue?vue&type=template&id=40b857f8&scoped=true&"
import script from "./noticelist.vue?vue&type=script&lang=js&"
export * from "./noticelist.vue?vue&type=script&lang=js&"
import style0 from "./noticelist.vue?vue&type=style&index=0&lang=css&"
import style1 from "./noticelist.vue?vue&type=style&index=1&id=40b857f8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40b857f8",
  null
  
)

export default component.exports